import { render, staticRenderFns } from "./SimplePrint.vue?vue&type=template&id=0622eb7c&"
import script from "./SimplePrint.vue?vue&type=script&lang=js&"
export * from "./SimplePrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports